import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as Actions from 'payment-calculator/actions/paymentCalculatorActions.js';
import 'payment-calculator/components/PaymentCalculatorDetails/components/FinanceMethodPage/FinanceMethodPage.scss';

import { PurchaseMethods, Vehicle, ModelYear } from '@sm360/widget-commons-vehicle';
import { LocaleService } from '@sm360/widget-commons-core-services';
import CustomizePayment from 'payment-calculator/components/PaymentCalculatorDetails/components/CustomizePayment/CustomizePayment.jsx';
import CalculatorCashdown from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorCashdown/CalculatorCashdown.jsx';
import CalculatorTerms from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTerms/CalculatorTerms.jsx';
import CalculatorTradein from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorTradein/CalculatorTradein.jsx';
import Distance from 'payment-calculator/components/Distance/Distance.jsx';
import CalculatorRebateStandardRate from 'payment-calculator/components/PaymentCalculatorDetails/components/CalculatorRebateStandardRate/CalculatorRebateStandardRate.jsx';
import ResidualValue from 'payment-calculator/components/ResidualValue/ResidualValue.jsx';

const FinanceMethodPage = ({ purchaseMethods, tradeInVehicle, actions, modelYear, displayCreditRate }) => {
    let kmPlanBlock;

    if (purchaseMethods.lease.selected) {
        kmPlanBlock = (
            <div>
                <Distance purchaseMethods={purchaseMethods} onKMPlanClick={actions.setKMPlan} modelYear={modelYear} />
                <ResidualValue residualValue={purchaseMethods.getSelectedPurchaseMethodResidualAmounts()} />
            </div>
        );
    }

    const { tradeIn, lien } = purchaseMethods;

    return (
        <div className="calculatorRow">
            <div className="calculatorColumn">
                <CustomizePayment
                    purchaseMethods={purchaseMethods}
                    updateTargetPayment={actions.updateTargetPayment}
                    selectPaymentFrequency={actions.selectPaymentFrequency}
                    setCashDown={actions.setCashDown}
                    modelYear={modelYear}
                />
                <CalculatorCashdown
                    setCashDown={actions.setCashDown}
                    purchaseMethods={purchaseMethods}
                    modelYear={modelYear}
                />
                {kmPlanBlock}
            </div>
            <div className="calculatorColumn">
                <CalculatorTerms purchaseMethods={purchaseMethods} displayCreditRate={displayCreditRate} />
                <div className="calculatorColumn__disclaimer">{LocaleService.t('PAYMENT_CALCULATOR.DISCLAIMER')}</div>
            </div>
            <div className="calculatorColumn">
                <CalculatorTradein
                    tradeInVehicle={tradeInVehicle}
                    tradeIn={tradeIn}
                    lien={lien}
                    setTradeIn={actions.setTradeIn}
                    setLien={actions.setLien}
                    modelYear={modelYear}
                    setShiftEvent={actions.setShiftEvent}
                />
                <CalculatorRebateStandardRate stdRebate={purchaseMethods.getSelectedRebatesAtStandardRate()} />
            </div>
        </div>
    );
};

FinanceMethodPage.defaultProps = {
    displayCreditRate: false,
};
FinanceMethodPage.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel).isRequired,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    modelYear: PropTypes.instanceOf(ModelYear.ModelYearModel).isRequired,
    actions: PropTypes.shape({
        updateTargetPayment: PropTypes.func.isRequired,
        selectPaymentFrequency: PropTypes.func.isRequired,
        setCashDown: PropTypes.func.isRequired,
        setTradeIn: PropTypes.func.isRequired,
        setLien: PropTypes.func.isRequired,
        setKMPlan: PropTypes.func.isRequired,
    }),
    displayCreditRate: PropTypes.bool,
};

FinanceMethodPage.defaultProps = {
    actions: [],
};

FinanceMethodPage.displayName = 'FinanceMethodPage';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethods,
        tradeInVehicle: state.tradeInVehicle,
        modelYear: state.modelYear,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FinanceMethodPage);
